import React, { useState } from 'react';
import { Toast, NavBar, Card, Empty, InfiniteScroll, List, Button, Space, Popup, DatePicker } from 'antd-mobile';
import axios from 'axios';
import API_ROUTES from '../../api';
import { useNavigate } from 'react-router-dom';
import './index.css';
import GameEventList from '../../Utils/GameEventList';
import { RedoOutline, CalendarOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs';

export default function GameHistory() {
    const navigate = useNavigate();
    const [gameList, setGameList] = useState([]);
    const [loadPage, setLoadPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [visible2, setVisible2] = useState(false);
    const [selectedRange, setSelectedRange] = useState([]);
    // New State for DatePicker logic
    const [datePickerVisible, setDatePickerVisible] = useState(false);
    const [isStartPicker, setIsStartPicker] = useState(true);

    const min = new Date(2020, 0, 1);
    const max = new Date();
    max.setMonth(max.getMonth() + 1);

    const defaultRange = [
        min,
        max
    ];

    const getGameInfo = (page, startTime, endTime) => {
        Toast.show({
            icon: 'loading',
            duration: 0
        });
        return axios.get(API_ROUTES.game_list, {
            params: {
                count: -1,
                status: "0,1,2,3,4",
                current: page,
                size: 10,
                startTime: startTime || min,
                endTime: endTime || max
            }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    return response.data.data.records;
                } else {
                    Toast.show({
                        icon: 'fail',
                    });
                    return [];
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
                return [];
            })
            .finally(() => {
                Toast.clear();
            });
    };

    async function loadMore() {
        const [startTime, endTime] = selectedRange.length > 0 ? selectedRange : defaultRange;
        const append = await getGameInfo(loadPage, startTime, endTime);
        setGameList(val => [...val, ...append]);
        setHasMore(append?.length > 0);
        const currentPage = loadPage + 1;
        setLoadPage(currentPage);
    }


    const handleReset = () => {
        setSelectedRange([]);
        setGameList([]);
        setLoadPage(1);
        setHasMore(true);
    };

    const getSelectedDateText = () => {
        if (selectedRange.length === 0) {
            return '';
        }
        const [start, end] = selectedRange;
        return `${dayjs(start).format('YYYY-MM-DD')} - ${dayjs(end).format('YYYY-MM-DD')}`;
    };

    return (
        <div className="history-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                赛事历史记录
            </NavBar>
            <div className="history-toolbar">
                <Space align='center'>
                    <Button
                        className="history-btn-glass"
                        size='small'
                        onClick={() => setVisible2(true)}
                    >
                        <CalendarOutline /> 筛选日期
                    </Button>
                    <span className="history-date-text">{getSelectedDateText()}</span>
                </Space>
                <Button
                    className="history-btn-glass history-btn-reset"
                    size='small'
                    onClick={handleReset}
                >
                    <RedoOutline /> 重置
                </Button>
            </div>


            {/* Custom Filter Popup */}
            <Popup
                visible={visible2}
                onMaskClick={() => setVisible2(false)}
                className="history-filter-popup"
                bodyStyle={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    minHeight: '40vh'
                }}
            >
                <div className="filter-popup-content">
                    <div className="filter-header">
                        <span>筛选时间</span>
                        <span className="filter-close" onClick={() => setVisible2(false)}>取消</span>
                    </div>

                    <div className="filter-section">
                        <div className="filter-section-title">快捷选项</div>
                        <div className="filter-tags">
                            <div
                                className="filter-tag"
                                onClick={() => {
                                    const end = new Date();
                                    const start = dayjs().subtract(1, 'month').toDate();
                                    setSelectedRange([start, end]);
                                    setGameList([]); setLoadPage(1); setHasMore(true);
                                    setVisible2(false);
                                }}
                            >近一月</div>
                            <div
                                className="filter-tag"
                                onClick={() => {
                                    const end = new Date();
                                    const start = dayjs().startOf('year').toDate();
                                    setSelectedRange([start, end]);
                                    setGameList([]); setLoadPage(1); setHasMore(true);
                                    setVisible2(false);
                                }}
                            >本年度</div>
                            <div
                                className="filter-tag"
                                onClick={() => {
                                    setSelectedRange([min, max]);
                                    setGameList([]); setLoadPage(1); setHasMore(true);
                                    setVisible2(false);
                                }}
                            >全部时间</div>
                        </div>
                    </div>

                    <div className="filter-section">
                        <div className="filter-section-title">自定义范围</div>
                        <div className="filter-date-inputs">
                            <div
                                className={`filter-date-box ${!selectedRange[0] ? 'placeholder' : ''}`}
                                onClick={() => {
                                    // Open Start Date Picker logic - Handled by DatePicker below
                                    setIsStartPicker(true);
                                    setDatePickerVisible(true);
                                }}
                            >
                                {selectedRange[0] ? dayjs(selectedRange[0]).format('YYYY-MM-DD') : '开始日期'}
                            </div>
                            <span className="filter-separator">-</span>
                            <div
                                className={`filter-date-box ${!selectedRange[1] ? 'placeholder' : ''}`}
                                onClick={() => {
                                    setIsStartPicker(false);
                                    setDatePickerVisible(true);
                                }}
                            >
                                {selectedRange[1] ? dayjs(selectedRange[1]).format('YYYY-MM-DD') : '结束日期'}
                            </div>
                        </div>
                    </div>

                    <Button
                        block
                        className="filter-confirm-btn"
                        onClick={() => {
                            setGameList([]);
                            setLoadPage(1);
                            setHasMore(true);
                            setVisible2(false);
                        }}
                    >
                        确认筛选
                    </Button>
                </div>
            </Popup>

            <DatePicker
                visible={datePickerVisible}
                onClose={() => setDatePickerVisible(false)}
                precision='day'
                min={min}
                max={max}
                value={isStartPicker ? (selectedRange[0] || new Date()) : (selectedRange[1] || new Date())}
                onConfirm={(val) => {
                    const newRange = [...(selectedRange.length ? selectedRange : [null, null])];
                    if (isStartPicker) {
                        newRange[0] = val;
                        // If end is missing or before start, set end = start
                        if (!newRange[1] || dayjs(newRange[1]).isBefore(val)) {
                            newRange[1] = val;
                        }
                    } else {
                        newRange[1] = val;
                        // If start is missing or after end, set start = end
                        if (!newRange[0] || dayjs(newRange[0]).isAfter(val)) {
                            newRange[0] = val;
                        }
                    }
                    setSelectedRange(newRange);
                    setDatePickerVisible(false);
                }}
            />


            {
                gameList?.length > 0 ?
                    <List className="history-list">
                        {gameList?.map((game, index) => (
                            <List.Item key={index}>
                                <div className="history-card-wrapper">
                                    <Card
                                        className="history-card"
                                        onClick={() => {
                                            if (game.status === 0) {
                                                navigate(`/games/${game.id}/signup`);
                                            } else if (game.status === 1) {
                                                navigate(`/games/${game.id}/ready`);
                                            } else if (game.status === 2) {
                                                navigate(`/games/${game.id}/live`);
                                            } else if (game.status === 3) {
                                                navigate(`/games/${game.id}/history`);
                                            }
                                        }}
                                    >
                                        <GameEventList gameInfo={game} />
                                    </Card>
                                </div>
                            </List.Item>
                        ))}
                    </List>
                    :
                    <Empty className="history-empty" description='暂无数据' />
            }


            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
    );
}
